<ng-container *ngIf="selectedVenue; else noData">
  <main [ngClass]="{
      'container-full': planningFullPage,
      'container-fluid': !planningFullPage
    }" class="d-flex flex-column gap-5">

    <planner-search [plannerType]="plannerType" *ngIf="!planningFullPage"></planner-search>

    <mat-expansion-panel *ngIf="!planningFullPage">
      <mat-expansion-panel-header>
        <mat-panel-title>
          <strong>Stock</strong>
        </mat-panel-title>
      </mat-expansion-panel-header>

      <!-- Lazy render: il contenuto viene creato solo quando il pannello si apre -->
      <ng-template matExpansionPanelContent>
        <planner-boxs [plannerType]="plannerType"></planner-boxs>
      </ng-template>
    </mat-expansion-panel>

    <router-outlet *ngIf="!planningFullPage"></router-outlet>

    <div *ngIf="plannerType === 'core' || plannerType === 'energy'">
      <div *ngIf="planningFullPage; else elseBlock">
        <planner-scheduler [fullScreen]="planningFullPage" (setPlanningFullScreen)="setPlanningFullScreen($event)">
        </planner-scheduler>
      </div>
      <ng-template #elseBlock>
        <mat-expansion-panel expanded>
          <mat-expansion-panel-header class="planner-header">
            <mat-panel-title class="planner-header__left">
              <strong>{{ "PLANNER.UPDATE_PLAN" | translate }}</strong>
            </mat-panel-title>

            <mat-panel-description class="planner-header__right">
              <span class="planner-header__nav">
                <button class="linklike" type="button"
                  (click)="$event.stopPropagation(); $event.preventDefault(); prevMonth()"
                  aria-label="Mese precedente">‹</button>

                <span class="planner-header__month">
                  {{ currentMonth | date:'LLLL y':undefined:'it-IT' }}
                </span>

                <button class="linklike" type="button"
                  (click)="$event.stopPropagation(); $event.preventDefault(); nextMonth()"
                  aria-label="Mese successivo">›</button>
              </span>
              <span class="mini-spinner" *ngIf="isLoadingMetrics" aria-label="Caricamento"></span>

              <div class="planner-header__metrics">
                <div class="mlc"><strong>MLC TOTALE: {{ mlcTotalePerc | number:'1.0-1' }}%</strong></div>
                <div class="mlc"><strong>MLC PREVISTO: {{ mlcPrevistoPerc | number:'1.0-1' }}%</strong></div>
              </div>
            </mat-panel-description>
          </mat-expansion-panel-header>


          <planner-scheduler [fullScreen]="planningFullPage" (setPlanningFullScreen)="setPlanningFullScreen($event)">
          </planner-scheduler>

          <mat-action-row></mat-action-row>
        </mat-expansion-panel>

      </ng-template>
    </div>

    <div *ngIf="plannerType === 'multi'">
      <mat-expansion-panel expanded>
        <mat-expansion-panel-header>
          <mat-panel-title>
            <strong>{{ "PLANNER.UPDATE_PLAN" | translate }}</strong>
          </mat-panel-title>
        </mat-expansion-panel-header>
        <planner-calendar></planner-calendar>
      </mat-expansion-panel>
    </div>
  </main>
</ng-container>
<ng-template #noData>
  <header class="noData">
    <h1>{{ "PLANNER.NO_ORDERS" | translate }}</h1>
  </header>
</ng-template>